// Author: Sunil Jain
// Timestamp: [Insert Current Timestamp e.g., 2025-04-10T11:20:00AM EDT]
// File: src/components/ProtectedRoute.js (Revised Logic)

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

const ProtectedRoute = ({ children }) => {
    // Get flags directly from AuthContext
    const { isAuthenticated, isLoading, user } = useAuth();
    const location = useLocation();

    console.log(`ProtectedRoute Render: isLoading=${isLoading}, isAuthenticated=${isAuthenticated}, user=${user ? user.id : null}`);


    // Check for token directly from localStorage using the correct key
    const token = localStorage.getItem('accessToken');

    // --- Loading State ---
    // Show spinner ONLY during the initial check managed by AuthContext
    if (isLoading) {
        console.log("ProtectedRoute: Auth context is loading initial user data...");
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="80vh">
                <CircularProgress />
            </Box>
        );
    }

    // --- Authentication Check ---
    if (!isAuthenticated) {
        console.log(`ProtectedRoute: Auth loaded, user is NOT authenticated (isAuthenticated: ${isAuthenticated}). Redirecting to login.`);
        // Clear token just in case it was invalid but didn't trigger error? (Optional safeguard)
        // localStorage.removeItem('token');
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // If a token *does* exist, we rely on AuthContext's isAuthenticated flag
    // which is based on the user data fetch result. If that fetch failed (e.g., invalid token),
    // isAuthenticated will be false. If fetch succeeded, it will be true.
    if (!isAuthenticated) {
        // This case handles situations where a token exists but is invalid (leading to user fetch failure)
        // or potentially if the user context hasn't updated *yet* after login.
        // Redirecting here ensures invalid tokens are handled.
        console.log(`ProtectedRoute: Auth loaded, token exists, but user is NOT authenticated (isAuthenticated: ${isAuthenticated}). Redirecting to login.`);
        // It's possible authFetch's 401 handler already logged out and cleared the token,
        // leading back to the !token check above on re-render, but this is a safeguard.
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // If loading is done and user is authenticated, render the children
    console.log("ProtectedRoute: Auth loaded, user authenticated. Rendering children.");
    return children;
};

export default ProtectedRoute;